/* ============================================================
   YOURSTORE THEME — Base JavaScript
   Vanilla JS, no framework dependencies.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Helpers --------------------------------------- */
  const $  = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);

  /* ---------- Body scroll lock ------------------------------ */
  let scrollLockCount = 0;
  function lockScroll() {
    scrollLockCount++;
    document.body.classList.add('is-locked');
  }
  function unlockScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) document.body.classList.remove('is-locked');
  }

  /* ---------- Drawer system --------------------------------- */
  function initDrawers() {
    $$('[data-drawer]').forEach(drawer => {
      const id = drawer.dataset.drawer;
      const open = (e) => { e && e.preventDefault(); drawer.classList.add('is-open'); lockScroll(); drawer.dispatchEvent(new CustomEvent('drawer:open')); };
      const close = () => { drawer.classList.remove('is-open'); unlockScroll(); drawer.dispatchEvent(new CustomEvent('drawer:close')); };
      drawer.openDrawer = open;
      drawer.closeDrawer = close;
      $$(`[data-drawer-open="${id}"]`).forEach(b => on(b, 'click', open));
      $$('[data-drawer-close]', drawer).forEach(b => on(b, 'click', close));
      const backdrop = $('.drawer__backdrop', drawer);
      on(backdrop, 'click', close);
      on(document, 'keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
    });
  }

  /* ---------- Sticky header (hide on scroll down) ----------- */
  function initStickyHeader() {
    const headers = $$('.site-header.umg-sticky');
    if (!headers.length) return;

    let lastY = window.scrollY;
    let ticking = false;

    const update = () => {
      const y = window.scrollY;
      const dy = y - lastY;
      const threshold = 60;
      headers.forEach(h => {
        if (y < threshold) {
          h.style.transform = '';
        } else if (dy > 4) {
          h.style.transform = 'translateY(-100%)';
        } else if (dy < -4) {
          h.style.transform = 'translateY(0)';
        }
      });
      lastY = y;
      ticking = false;
    };

    on(window, 'scroll', () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    // Update --header-height variable for sticky offsets in CSS
    const setHeight = () => {
      const visible = headers.find(h => h.offsetParent !== null);
      if (visible) document.documentElement.style.setProperty('--header-height', visible.offsetHeight + 'px');
    };
    setHeight();
    on(window, 'resize', setHeight);
  }

  /* ---------- Quantity input -------------------------------- */
  function initQuantity() {
    $$('[data-quantity]').forEach(wrap => {
      const input = $('input[type="number"]', wrap);
      if (!input) return;
      const minus = $('[data-quantity-minus]', wrap);
      const plus  = $('[data-quantity-plus]', wrap);
      const setVal = (v) => {
        const min = parseInt(input.min || '1', 10);
        const max = parseInt(input.max || '999', 10);
        v = Math.min(max, Math.max(min, v));
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      on(minus, 'click', () => setVal(parseInt(input.value, 10) - 1));
      on(plus,  'click', () => setVal(parseInt(input.value, 10) + 1));
    });
  }

  /* ---------- Accordion ------------------------------------- */
  function initAccordion() {
    $$('[data-accordion]').forEach(acc => {
      const trigger = $('[data-accordion-trigger]', acc);
      const content = $('[data-accordion-content]', acc);
      if (!trigger || !content) return;
      const opened = acc.dataset.open === 'true';
      acc.classList.toggle('is-open', opened);
      on(trigger, 'click', () => acc.classList.toggle('is-open'));
    });
  }

  /* ---------- Cart count badge ------------------------------ */
  // Updates [data-cart-count] elements after add-to-cart.
  // Usage: dispatch CustomEvent('cart:updated', {detail: {item_count}}) on document.
  function initCartCount() {
    on(document, 'cart:updated', (e) => {
      const count = (e.detail && e.detail.item_count) || 0;
      $$('[data-cart-count]').forEach(el => {
        el.textContent = count;
        el.dataset.empty = count === 0 ? 'true' : 'false';
      });
    });
  }

  /* ---------- Init ------------------------------------------ */
  function init() {
    initDrawers();
    initStickyHeader();
    initQuantity();
    initAccordion();
    initCartCount();
  }

  if (document.readyState === 'loading') {
    on(document, 'DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose tiny API for sections to use
  window.theme = {
    lockScroll, unlockScroll,
    $, $$,
  };
})();
